import { useToggleable } from '../../../../hooks';
export var useScheduleTrigger = function () {
    return useToggleable(false);
};
